// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"7c6060ff","626":"3559797d"}[chunkId] + ".chunk.js";
};